import { IRaterProps } from './types';
import {
  Submission,
  IUnderwritingQuote,
  RaterMode,
  RaterPolicyDetails,
  RaterUserQuotes,
} from '@converge/graphql';
import { memo } from 'react';
import {
  RaterActionsContext,
  RaterDispatchContext,
  RaterStateContext,
  useRaterReducer,
} from './data';
import { RaterInner } from './rater.inner';

export interface IRaterInnerProviderProps extends IRaterProps {
  quote: IUnderwritingQuote;
  submission: Submission;
  userQuotes: RaterUserQuotes;
  isEditable: boolean;
  mode: RaterMode;
  policy?: RaterPolicyDetails;
}

export const RaterInnerProvider = memo(
  ({
    quote,
    submission,
    userQuotes,
    policy,
    mode,
    isEditable,
  }: IRaterInnerProviderProps) => {
    const [state, dispatch, actions] = useRaterReducer(
      { mode, isEditable },
      quote,
      submission,
      userQuotes,
      policy
    );
    return (
      <RaterStateContext.Provider value={state}>
        <RaterDispatchContext.Provider value={dispatch}>
          <RaterActionsContext.Provider value={actions}>
            <RaterInner
              mode={mode}
              policy={policy}
              isEditable={isEditable}
              quote={quote}
              submission={submission as Submission}
              userQuotes={userQuotes}
            />
          </RaterActionsContext.Provider>
        </RaterDispatchContext.Provider>
      </RaterStateContext.Provider>
    );
  }
);
